/* Lite theme: product gallery and the bundle bars that double as the variant picker. */
(() => {
  const d = document;
  const smooth = () => (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');

  const gal = d.querySelector('[data-gallery]');
  const slides = gal && gal.querySelector('[data-slides]');
  const items = slides ? [...slides.children] : [];
  // Photos after the first get their source once the first has loaded, or at the first touch of the gallery.
  const held = gal ? [...gal.querySelectorAll('img[data-src]')] : [];
  const wake = () => held.splice(0).forEach(img => {
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
  });
  if (held.length) {
    const first = items[0] && items[0].querySelector('img');
    if (!first || first.complete) wake();
    else { first.addEventListener('load', wake, { once: true }); first.addEventListener('error', wake, { once: true }); }
    ['pointerdown', 'scroll', 'focusin', 'mouseover'].forEach(t => gal.addEventListener(t, wake, { once: true, passive: true, capture: true }));
  }
  const go = i => { const s = items[i]; wake(); if (s) slides.scrollTo({ left: s.offsetLeft, behavior: smooth() }); };
  if (items.length > 1) {
    const marks = [...gal.querySelectorAll('[data-to]')];
    gal.addEventListener('click', e => { const b = e.target.closest('[data-to]'); if (b) go(+b.dataset.to); });
    const io = new IntersectionObserver(es => es.forEach(en => {
      if (!en.isIntersecting) return;
      const i = String(items.indexOf(en.target));
      marks.forEach(m => m.toggleAttribute('aria-current', m.dataset.to === i));
    }), { root: slides, threshold: 0.6 });
    items.forEach(s => io.observe(s));
  }
  const showMedia = id => { const i = items.findIndex(s => s.dataset.mediaId === String(id)); if (i > -1) go(i); };

  const form = d.querySelector('[data-buy]');
  if (!form) return;
  const data = JSON.parse(form.querySelector('[data-variants]').textContent).v;
  const variants = data.map(v => ({ id: v[0], opts: v[1], ok: v[2], price: v[3], cmp: v[4], media: v[5] }));
  const fmt = form.dataset.money || '${{amount}}';
  const money = c => {
    const n = (c / 100).toFixed(2).split('.');
    const group = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return group(String(Math.round(c / 100)), ',');
      if (k === 'amount_with_comma_separator') return group(n[0], '.') + ',' + n[1];
      if (k === 'amount_no_decimals_with_comma_separator') return group(String(Math.round(c / 100)), '.');
      if (k === 'amount_with_apostrophe_separator') return group(n[0], "'") + '.' + n[1];
      return group(n[0], ',') + '.' + n[1];
    });
  };

  const rows = [...form.querySelectorAll('[data-row]')];
  const box = form.querySelector('[data-rows]');
  const tiers = [...form.querySelectorAll('[data-tier]')];
  const mainId = form.querySelector('[data-main-id]');
  const btn = form.querySelector('[data-add]');
  const err = form.querySelector('[data-error]');
  const single = variants.length === 1 && !rows.length;
  const thumbEl = form.querySelector('[data-thumbs]');
  const thumbs = thumbEl ? JSON.parse(thumbEl.textContent) : null;
  const touched = new Set();
  let busy = false;

  const picks = row => [...row.querySelectorAll('[data-opt]')].map(s => s.value);
  const find = vals => variants.find(v => v.opts.every((o, i) => o === vals[i]));
  const pick = row => (row ? find(picks(row)) : variants.find(v => String(v.id) === mainId.value) || variants[0]);
  const setRow = (row, vals) => row.querySelectorAll('[data-opt]').forEach((s, i) => { s.value = vals[i]; });
  const checked = () => form.querySelector('input[name="tier"]:checked');
  const qty = () => { const t = checked(); return t ? +t.value : 1; };

  // A value is marked sold out when no available variant has it together with the row's other choices.
  function label(row) {
    const sels = [...row.querySelectorAll('[data-opt]')];
    const vals = sels.map(s => s.value);
    sels.forEach((s, i) => [...s.options].forEach(o => {
      const want = vals.slice(); want[i] = o.value;
      const v = find(want);
      const txt = o.value + (v && v.ok ? '' : ' — ' + btn.dataset.soldout);
      if (o.textContent !== txt) o.textContent = txt;
    }));
  }

  // Units per variant. The store's discount is rounded per unit, so how lines merge never changes the total.
  function lines(n) {
    const m = new Map();
    for (let i = 0; i < n; i++) {
      const v = single ? variants[0] : pick(rows[i] || rows[0]);
      if (!v) return null;
      m.set(v, (m.get(v) || 0) + 1);
    }
    return m;
  }

  function prices() {
    tiers.forEach(t => {
      const r = t.querySelector('input[name="tier"]');
      const m = lines(+r.value);
      if (!m) return;
      const pct = parseFloat(r.dataset.pct) || 0;
      let total = 0, cmp = 0;
      m.forEach((q, v) => {
        total += (v.price - Math.round(v.price * pct / 100)) * q;
        cmp += Math.max(v.cmp, v.price) * q;
      });
      total = Math.max(0, total - (parseInt(r.dataset.off, 10) || 0));
      t.querySelector('[data-tp]').textContent = money(total);
      t.querySelector('[data-tc]').textContent = cmp > total ? money(cmp) : '';
      const s = t.querySelector('[data-ts]');
      s.hidden = cmp <= total;
      if (cmp > total) s.textContent = s.dataset.tpl.replace('[amount]', money(cmp - total));
    });
  }

  function update() {
    const n = qty();
    rows.forEach((row, i) => { row.hidden = i >= n; });
    const head = checked() && checked().closest('[data-tier]');
    if (box && head && box.parentNode !== head) head.append(box);
    rows.forEach(label);
    if (thumbs) rows.forEach(row => {
      const img = row.querySelector('[data-row-img]');
      const v = pick(row);
      const u = img && v && thumbs[v.media];
      if (u && img.getAttribute('src') !== u) img.src = u;
    });
    const m = lines(n);
    const ok = !!m && [...m.keys()].every(v => v.ok);
    const first = pick(rows[0]);
    if (first) mainId.value = first.id;
    btn.disabled = busy || !ok;
    btn.textContent = ok ? btn.dataset.label : btn.dataset.soldout;
    prices();
  }

  form.addEventListener('change', e => {
    const t = e.target;
    err.hidden = true;
    if (t.name === 'tier') {
      rows.forEach((row, i) => { if (i && !touched.has(row)) setRow(row, picks(rows[0])); });
      update();
      return;
    }
    if (!t.matches('[data-opt]')) return;
    const row = t.closest('[data-row]');
    const vals = picks(row);
    const v = find(vals);
    if (!v || !v.ok) {
      const i = +t.dataset.opt;
      const alt = variants.find(x => x.ok && x.opts[i] === t.value);
      if (alt) setRow(row, alt.opts);
    }
    if (row === rows[0]) {
      rows.forEach((r, i) => { if (i && !touched.has(r)) setRow(r, picks(rows[0])); });
      const f = pick(rows[0]);
      if (f && f.media) showMedia(f.media);
    } else touched.add(row);
    update();
  });

  form.addEventListener('submit', e => {
    if (!window.theme) return;
    e.preventDefault();
    const m = lines(qty());
    if (!m || busy || btn.disabled) return;
    const list = [...m].map(([v, q]) => ({ id: v.id, quantity: q }));
    busy = btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    err.hidden = true;
    theme.cart.add(list).then(() => theme.cart.open(false), x => {
      err.textContent = x.message;
      err.hidden = false;
    }).finally(() => {
      busy = false;
      btn.removeAttribute('aria-busy');
      update();
    });
  });

  update();
})();
